import { Action, createReducer, on } from '@ngrx/store';
import { stat } from 'fs';
import * as articleActions from '../action/article.action';
import { ArticleModel } from '../model/article.model';

export interface ArticleState {
    article: ArticleModel,
    isDownloading: boolean,
    isDownloadingSuccess: boolean,
    isDownloadingFailure: boolean,
    error: string
}

export const initialState: ArticleState = {
    article: {} as ArticleModel,
    isDownloading: false,
    isDownloadingSuccess: false,
    isDownloadingFailure: false,
    error: ''
};

const articleReducer = createReducer(
    initialState,
    on(articleActions.article, (state) =>
    ({
        article: state.article,
        isDownloading: true,
        isDownloadingSuccess: false,
        isDownloadingFailure: false,
        error: ''
    })),
    on(articleActions.articleSuccess, (_, response) =>
    ({
        article: response.article,
        isDownloading: false,
        isDownloadingSuccess: true,
        isDownloadingFailure: false,
        error: ''
    })),
    on(articleActions.articleFailure, (state, response) =>
    ({
        article: state.article,
        isDownloading: false,
        isDownloadingSuccess: false,
        isDownloadingFailure: true,
        error: response.error
    }))
)

export function article(
    state: ArticleState | undefined,
    action: Action
): ArticleState {
    return articleReducer(state, action);
}
